import { render, staticRenderFns } from "./NotificationsDesktop.vue?vue&type=template&id=72cb4afb&scoped=true"
import script from "./NotificationsDesktop.vue?vue&type=script&lang=js"
export * from "./NotificationsDesktop.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDesktop.vue?vue&type=style&index=0&id=72cb4afb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cb4afb",
  null
  
)

export default component.exports